//export const faces_ID= ["E","N","S","O"]
/* export const faces_names={
    "E":"Este",
    "N":"Norte",
    "S":"Sud",
    "O":"Oeste"
}

export const face_num_name={
    "-90":"S",
    "90":"N",
    "0":"E",
    "180":"O"
} */

export const faces_ID = ["N", "S", "E", "O"];
export const faces_names = {
  N: "Norte",
  S: "Sud",
  E: "Este",
  O: "Oeste",
};

export const face_num_name = {
  "-90": "O",
  90: "E",
  0: "S",
  180: "N",
};
